import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from '../Pages/Home';
import About from '../Pages/About';
import Products from '../Pages/Products';
import Projects from '../Pages/Projects';
import ContactUs from '../Pages/ContactUs';
import DynamicProductDetail from '../Pages/DynamicProductDetail';
import DynamicProjectDetail from '../Pages/DynamicProjectDetail';
import Error from '../Pages/Error';
import ScrollToTop from '../Common/ScrollToTop';
import SmoothScroll from '../Common/SmoothScroll';

class AppRouter extends React.Component {
    render() {
        return (
            <BrowserRouter basename="/">
                <SmoothScroll />
                <ScrollToTop />
                <div className="page-wraper">
                    <Routes>
                        {/* MAIN WEBSITE PAGES */}
                        <Route path='/' element={<Home />} />
                        <Route path='/about-us' element={<About />} />
                        <Route path='/products' element={<Products />} />
                        <Route path='/projects' element={<Projects />} />
                        <Route path='/contact-us' element={<ContactUs />} />

                        {/* DYNAMIC DETAIL PAGES (SUPPORT BOTH SINGULAR & PLURAL URL ALIASES) */}
                        <Route path='/product/:id' element={<DynamicProductDetail />} />
                        <Route path='/products/:id' element={<DynamicProductDetail />} />
                        <Route path='/product-detail/:id' element={<DynamicProductDetail />} />
                        <Route path='/product-details/:id' element={<DynamicProductDetail />} />

                        <Route path='/project/:id' element={<DynamicProjectDetail />} />
                        <Route path='/projects/:id' element={<DynamicProjectDetail />} />
                        <Route path='/project-detail/:id' element={<DynamicProjectDetail />} />
                        <Route path='/project-details/:id' element={<DynamicProjectDetail />} />

                        {/* FALLBACK ROUTE */}
                        <Route path='*' element={<Error />} />
                    </Routes>
                </div>
            </BrowserRouter>
        );
    };
};

export default AppRouter;
